<template v-slot:default>
    <Popup ref="popup" :animation="'scale'" :shadowOpacity="0.7" @ontransitionend="onTransitionEnd">
        <div class="collect-cont">
            <div class="rewards">
                <img class="collect-bg" :src="_global.assetsRoot + '/collect_popup_bg.png'" />
                <div class="items">
                    <div class="title">
                        <span class="fs-4 segoe">{{ $t("message.success") }}</span>
                    </div>
                    <div class="text">
                        <span class="fs-1-5 segoe">{{ $t("message.credited") }}</span>
                    </div>
                    <div class="reward-items">
                        <div class="coins reward v-m" v-if="data.coins > 0">
                            <div class="coins-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/balance_coins_icon.png'" />
                            </div>
                            <div class="coins-count count t-c">
                                <span class="segoe fs-2-5">{{ coins }}</span>
                            </div>
                        </div>
                        <div class="chips reward v-m" v-if="data.chips > 0">
                            <div class="chips-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/balance_dinero_icon.png'" />
                            </div>
                            <div class="chips-count count t-c">
                                <span class="segoe fs-2-5">{{ chips }}</span>
                            </div>
                        </div>
                        <div class="wheel reward v-m" v-if="data.wheel">
                            <div class="wheel-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/bundles_wheel_pic.png'" />
                            </div>
                            <div class="wheel-text count t-c">
                                <span class="segoe fs-2">{{ $t("message.freeWheel") }}</span>
                            </div>
                        </div>
                        <div class="wheel reward v-m" v-if="data.blackwheel">
                            <div class="wheel-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/black_wheel_pic.png'" />
                            </div>
                            <div class="wheel-text count t-c">
                                <span class="segoe fs-2">{{ $t("message.blackWheel") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btn-item">
                        <div ref="collectBtn" class="btn collect-btn t-c" @click.stop="collect">
                            <span class="segoe fs-1-2">{{ $t("message.okay") }}</span>
                        </div>
                        <div ref="goDrBingoBtn" class="btn go-dr-bingo-btn t-c" @click.stop="goDrBingo">
                            <span class="segoe fs-1-2">{{ $t("message.goDrBingo") }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:second="">
            <BonusAnimation ref="bonusAnimation" :from="from" :to="to"></BonusAnimation>
        </template>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue';
import BonusAnimation from '../animations/BonusAnimation.vue';
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Object,
        to: Object
    },
    data() {
        return {
            isShow: false,
            from: null,
            collected: false
        }
    },
    computed: {
        coins() { return utils.fc(this.data ? (this.data.coins || 0) : 0) },
        chips() { return utils.fc(this.data ? (this.data.chips || 0) : 0) }
    },
    methods: {
        show() { this.isShow = true, this.$refs.popup.show(), (this.collected = false) },
        hide() { this.isShow = false, this.$refs.popup.hide() },
        onTransitionEnd() {
            if (this.isShow) {
                let pos = this.$refs.collectBtn.getBoundingClientRect();
                this.from = { x: pos.left + pos.width / 2, y: pos.top + pos.height / 2 };
            }
        },
        collect() {
            if (this.collected) return;
            this.collected = true;
            if (typeof this.data.isFree !== 'undefined' && this.data.isFree) {
                let items = [];
                this.data.coins && this.data.coins > 0 && items.push({ "type": "coins", "data": this.data.coins });
                this.data.chips && this.data.chips > 0 && items.push({ "type": "chips", "data": this.data.chips });
                this.$emit("tanimation", { items: items })
                this.showBonusAnimation();
            } else this.$emit("collect", { pendingId: this.data.pendingId });
        },
       goDrBingo() {
        const appUrlScheme = "drbingo://";
        const fallbackUrlAndroid = "https://play.google.com/store/apps/details?id=com.gamesmartltd.doctorbingo";
        const fallbackUrliOS = "https://apps.apple.com/us/app/dr-bingo-videobingo-slots/id1152226735";
        const fallbackUrlDesktop = "https://www.drbingo.com/";

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        const openApp = () => {
            if ((/android/i.test(userAgent)) || ((/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream))) {
                window.location.href = appUrlScheme;
            }else {
                this.$refs.popup.hide();
                window.open(fallbackUrlDesktop, '_blank');
            }
        };

        const openFallbackUrl = () => {
            if (/android/i.test(userAgent)) {
                window.open(fallbackUrlAndroid, '_blank');
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.open(fallbackUrliOS, '_blank');
            } else {
                window.open(fallbackUrlDesktop, '_blank');
            }
        };

        // Check if the app is installed
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = appUrlScheme;
        document.body.appendChild(iframe);

        const timeout = setTimeout(() => {
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
                openFallbackUrl();
            }
        }, 2000);

        window.addEventListener('blur', () => {
            clearTimeout(timeout);
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
            }
        }, { once: true });

        openApp();
    },
        showBonusAnimation() {
            this.$refs.bonusAnimation.show();
            this.$refs.bonusAnimation.startAnimation(this.data.coins && this.data.coins > 0, this.data.chips && this.data.chips > 0, this.from, this.to, () => {
                this.hide()
            });
        }
    },
    components: { Popup, BonusAnimation }
}
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";

.collect-cont {
    display: inline-block;

    .rewards {
        position: relative;

        .collect-bg {
            width: 35rem;
        }

        .items {
            position: absolute;
            width: 100%;
            left: 0;
            top: 10rem;

            .title {

                span {
                    color: #1B279F;
                    text-shadow: 0 3px 3px #FFF, 3px 0 3px #FFF, 0 -3px 3px #FFF, -3px 0 3px #FFF;
                    -webkit-text-shadow: 0 3px 3px #FFF, 3px 0 3px #FFF, 0 -3px 3px #FFF, -3px 0 3px #FFF;
                }
            }

            .text {
                margin: .5rem 0;

                span {
                    color: #FFF;
                    letter-spacing: 1px;
                    text-shadow: 0 2px 2px #000;
                    -webkit-text-shadow: 0 2px 2px #000;
                }
            }

            .reward-items {
                box-sizing: border-box;
                padding: 0 4rem;

                .reward {
                    height: 4rem;
                    line-height: 4rem;
                    display: flex;
                    flex-direction: row;

                    .icon {
                        flex-basis: 6rem;

                        img {
                            height: 3rem;
                        }
                    }

                    .count {
                        flex: 1;
                    }

                    .coins-count span {
                        color: #FFD800;
                    }

                    .chips-count span {
                        color: #B9FF00;
                    }

                    .wheel-text {
                        color: #FFC332;
                    }
                }
            }

            .btn-item {
                margin-top: .8rem;

                .collect-btn {
                    display: inline-block;
                    width: 16rem;
                    height: 4.8rem;
                    line-height: 4.5rem;
                    background: url($assetRoot + "/collect_button.png") center no-repeat;
                    background-size: 100% 100%;

                    span {
                        color: #FFF;
                    }
                }
            }
        }
    }
    .btn-item {
    margin-top: .8rem;
    display: flex;
    justify-content: space-between;

    .collect-btn, .go-dr-bingo-btn {
        display: inline-block;
        width: 16rem;
        height: 4.8rem;
        line-height: 4.5rem;
        background-size: 100% 100%;
        span {
            color: #FFF;
        }
    }

    .collect-btn {
        background: url($assetRoot + "/collect_button.png") center no-repeat;
    }

    .go-dr-bingo-btn {
        background: url($assetRoot + "/button_go_drbingo.png") center no-repeat;
        background-size: contain;
        background-position: center;
    }
}

}
</style>



// WEBPACK FOOTER //
// src/components/popup/Collect.vue